import {customElement, property} from "lit/decorators.js";
import {UnLitElement} from "../../../common/elements";
import {Dialogs} from "./dialogs";
import {resolve} from "../../../container";


@customElement("eop-download-dialog")
export class EopDownloadDialog extends UnLitElement {

    @property({attribute: "lightbox-dialog-id"})
    public lightboxDialogId: string;
    @property({attribute: "disclaimer-dialog-id"})
    public disclaimerDialogId: string;

    public constructor(private dialogs: Dialogs = resolve(Dialogs)) {
        super();
    }

    public connectedCallback(): void {
        super.connectedCallback();

        if (this.lightboxDialogId) {
            this.openLightboxDialogOnPreviewImageInteraction();
        } else if (this.disclaimerDialogId) {
            this.openDisclaimerDialogOnPreviewImageInteraction();
            this.querySelector(".download-label")!.addEventListener("click", event => this.openDisclaimerDialogFromInteraction(event));
        }
    }

    private openLightboxDialogOnPreviewImageInteraction(): void {
        const previewImageElement = this.querySelector(".download-preview-image");
        if (previewImageElement !== null) {
            previewImageElement.addEventListener("click", event => this.openLightboxDialogFromInteraction(event));
        }
    }

    private openDisclaimerDialogOnPreviewImageInteraction(): void {
        const previewImageElement = this.querySelector(".download-preview-image");
        if (previewImageElement !== null) {
            previewImageElement.addEventListener("click", event => this.openDisclaimerDialogFromInteraction(event));
        }
    }

    private openLightboxDialogFromInteraction(event: Event): void {
        event.preventDefault();
        this.dialogs.open(this.lightboxDialogId);
    }

    private openDisclaimerDialogFromInteraction(event: Event): void {
        event.preventDefault();
        this.dialogs.open(this.disclaimerDialogId);
    }
}
